// ============================================================
// DRAVONIX ULTIMATE - 9 PROJECTS DATA
// HTML files: /1.html to /9.html in public folder
// ============================================================

export const projects = [
  {
    id: 'nexus-defi',
    slug: 'nexus-defi-protocol',
    htmlFile: '/1.html',
    title: 'Nexus DeFi Protocol',
    tagline: 'Next-Gen Yield Optimization',
    category: 'DeFi',
    color: 'cyan',
    icon: 'fa-chart-line',
    description: 'Revolutionary DeFi protocol featuring automated yield optimization, liquidity aggregation, and cross-chain farming strategies.',
    heroDescription: 'Nexus DeFi is the next evolution in decentralized finance. Our protocol automatically finds and allocates capital to the highest-yielding opportunities across multiple chains, while maintaining institutional-grade security and transparency.',
    features: [
      { icon: 'fa-robot', title: 'Auto-Compounding', text: 'Vaults automatically compound rewards for maximum APY' },
      { icon: 'fa-link', title: 'Cross-Chain', text: 'Farm yields across Ethereum, BSC, Polygon, Arbitrum, and more' },
      { icon: 'fa-shield-alt', title: 'Audited Security', text: 'Multiple audits by Certik, Trail of Bits, and OpenZeppelin' },
      { icon: 'fa-users', title: 'Governance', text: 'NEX token holders vote on protocol upgrades and treasury' },
      { icon: 'fa-chart-pie', title: 'Analytics', text: 'Real-time dashboards showing yields, TVL, and performance' },
      { icon: 'fa-coins', title: 'Revenue Share', text: 'Protocol fees distributed to NEX stakers' }
    ],
    stats: { tvl: '$12.5M', apy: '45%', users: '8,500+', chains: '6' },
    tech: ['Solidity', 'React', 'TheGraph', 'Chainlink', 'IPFS', 'Hardhat']
  },
  {
    id: 'citrus-nft',
    slug: 'citrus-nft',
    htmlFile: '/2.html',
    title: 'Citrus NFT',
    tagline: 'Multi-Chain NFT Marketplace',
    category: 'NFT',
    color: 'orange',
    icon: 'fa-image',
    description: 'Premium NFT marketplace with lazy minting, creator royalties, and seamless cross-chain NFT transfers.',
    heroDescription: 'Citrus NFT is where creators and collectors come together. Our marketplace features zero-gas lazy minting, customizable royalties up to 10%, and the ability to bridge your NFTs across chains. Discover unique digital art and collectibles.',
    features: [
      { icon: 'fa-magic', title: 'Lazy Minting', text: 'Create NFTs without paying gas until sold' },
      { icon: 'fa-percentage', title: 'Creator Royalties', text: 'Earn up to 10% on every secondary sale' },
      { icon: 'fa-bridge', title: 'Cross-Chain', text: 'Bridge NFTs between Ethereum, Polygon, and Solana' },
      { icon: 'fa-gavel', title: 'Auctions', text: 'English and Dutch auction formats' },
      { icon: 'fa-star', title: 'Curation', text: 'Featured drops and verified creator badges' },
      { icon: 'fa-users', title: 'Social', text: 'Follow creators, like, and comment on NFTs' }
    ],
    stats: { volume: '$2.5M', nfts: '50,000+', creators: '2,000+', sales: '15,000+' },
    tech: ['Next.js', 'Solidity', 'IPFS', 'Moralis', 'Alchemy', 'TheGraph']
  },
  {
    id: 'vaultx-wallet',
    slug: 'vaultx-wallet',
    htmlFile: '/vaultx/index.html',
    title: 'VaultX Wallet',
    tagline: 'Secure Multi-Chain Wallet',
    category: 'Wallet',
    color: 'gold',
    icon: 'fa-wallet',
    description: 'Non-custodial wallet supporting 20+ chains with biometric auth, DApp browser, and hardware wallet integration.',
    heroDescription: 'VaultX puts you in complete control of your crypto assets. With support for 20+ blockchains, military-grade security, and seamless DApp integration, VaultX is the only wallet you need. Your keys, your crypto, your freedom.',
    features: [
      { icon: 'fa-link', title: '20+ Chains', text: 'Ethereum, Bitcoin, Solana, Cosmos, and many more' },
      { icon: 'fa-fingerprint', title: 'Biometric', text: 'Face ID and fingerprint authentication' },
      { icon: 'fa-globe', title: 'DApp Browser', text: 'Access any Web3 application seamlessly' },
      { icon: 'fa-microchip', title: 'Hardware Support', text: 'Ledger and Trezor integration' },
      { icon: 'fa-exchange-alt', title: 'Built-in Swap', text: 'DEX aggregator for best rates' },
      { icon: 'fa-bell', title: 'Notifications', text: 'Price alerts and transaction updates' }
    ],
    stats: { downloads: '150K+', chains: '20+', rating: '4.9★', assets: '$500M+' },
    tech: ['React Native', 'Web3.js', 'Ethers.js', 'Swift', 'Kotlin', 'WalletConnect']
  },
  {
    id: 'swiftswap-dex',
    slug: 'swiftswap-dex',
    htmlFile: '/swiftswap/index.html',
    title: 'SwiftSwap DEX',
    tagline: 'High-Speed DEX Platform',
    category: 'DEX',
    color: 'emerald',
    icon: 'fa-exchange-alt',
    description: 'Decentralized exchange with concentrated liquidity, limit orders, and MEV protection.',
    heroDescription: 'SwiftSwap delivers the speed and features of centralized exchanges with full decentralization. Trade with confidence using our advanced order types, concentrated liquidity pools, and built-in MEV protection. Your trades, your rules.',
    features: [
      { icon: 'fa-tint', title: 'Concentrated Liquidity', text: 'Capital-efficient pools with custom price ranges' },
      { icon: 'fa-list-ol', title: 'Limit Orders', text: 'Set your price and walk away' },
      { icon: 'fa-shield-alt', title: 'MEV Protection', text: 'Private transactions prevent frontrunning' },
      { icon: 'fa-random', title: 'Cross-Chain', text: 'Swap assets across different networks' },
      { icon: 'fa-seedling', title: 'Yield Farming', text: 'Earn SWIFT tokens by providing liquidity' },
      { icon: 'fa-chart-area', title: 'Pro Charts', text: 'TradingView integration with indicators' }
    ],
    stats: { volume: '$5M/day', pairs: '500+', tvl: '$25M', slippage: '0.01%' },
    tech: ['Solidity', 'Uniswap V3', 'React', 'TheGraph', 'Chainlink', 'Gelato']
  },
  {
    id: 'dragon-quest',
    slug: 'dragon-quest-p2e',
    htmlFile: '/dragon-quest/index.html',
    title: 'Dragon Quest P2E',
    tagline: 'Epic Play-to-Earn RPG',
    category: 'GameFi',
    color: 'purple',
    icon: 'fa-gamepad',
    description: 'Immersive P2E gaming with NFT dragons, PvP battles, guilds, and real token rewards.',
    heroDescription: 'Enter the realm of Dragon Quest where every battle counts and every dragon is a unique NFT. Build your collection, join guilds, compete in tournaments, and earn real rewards. The most engaging play-to-earn RPG in Web3.',
    features: [
      { icon: 'fa-dragon', title: 'NFT Dragons', text: '10,000+ unique dragons with traits and abilities' },
      { icon: 'fa-khanda', title: 'PvP Battles', text: 'Real-time battles with skill-based combat' },
      { icon: 'fa-users', title: 'Guilds', text: 'Join forces for raids and guild wars' },
      { icon: 'fa-trophy', title: 'Tournaments', text: 'Weekly competitions with prize pools' },
      { icon: 'fa-dna', title: 'Breeding', text: 'Breed dragons to create rare offspring' },
      { icon: 'fa-coins', title: 'Earn DQT', text: 'Dragon Quest Tokens from gameplay' }
    ],
    stats: { players: '75K+', nfts: '150K+', earned: '$5M+', daily: '12K+' },
    tech: ['Unity', 'Solidity', 'Node.js', 'MongoDB', 'IPFS', 'PlayFab']
  },
  {
    id: 'luxestore-pro',
    slug: 'luxestore-pro',
    htmlFile: '/luxestore-pro/index.html',
    title: 'LuxeStore Pro',
    tagline: 'Premium E-Commerce Platform',
    category: 'E-Commerce',
    color: 'cyan',
    icon: 'fa-store',
    description: 'High-converting e-commerce with crypto payments, AI recommendations, and headless architecture.',
    heroDescription: 'LuxeStore Pro is the ultimate e-commerce solution for forward-thinking brands. Accept crypto payments, leverage AI for personalized recommendations, and scale infinitely with our headless architecture. The future of online retail.',
    features: [
      { icon: 'fa-bitcoin', title: 'Crypto Payments', text: 'Accept 50+ cryptocurrencies seamlessly' },
      { icon: 'fa-robot', title: 'AI Recommendations', text: 'Personalized product suggestions boost AOV' },
      { icon: 'fa-code', title: 'Headless', text: 'Flexible architecture for any frontend' },
      { icon: 'fa-globe', title: 'Multi-Currency', text: 'Fiat and crypto with auto-conversion' },
      { icon: 'fa-box', title: 'Inventory', text: 'Real-time stock management across channels' },
      { icon: 'fa-chart-line', title: 'Analytics', text: 'Deep insights into customer behavior' }
    ],
    stats: { orders: '100K+', conversion: '4.8%', revenue: '$15M+', merchants: '500+' },
    tech: ['Next.js', 'Node.js', 'Stripe', 'PostgreSQL', 'Redis', 'Elasticsearch']
  },
  {
    id: 'algora-ai',
    slug: 'algora-ai-launchpad',
    htmlFile: '/algora-launchpad/index.html',
    title: 'Algora AI Launchpad',
    tagline: 'AI-Powered Token Launch',
    category: 'Launchpad',
    color: 'purple',
    icon: 'fa-rocket',
    description: 'Multi-chain token launchpad with AI-driven vetting, fair launch mechanics, and investor protection.',
    heroDescription: 'Algora AI revolutionizes token launches with artificial intelligence. Our AI analyzes projects for legitimacy, our fair launch mechanics prevent bots, and our multi-chain support means one launch, multiple networks. The smartest way to launch.',
    features: [
      { icon: 'fa-brain', title: 'AI Vetting', text: 'ML models score project legitimacy and potential' },
      { icon: 'fa-balance-scale', title: 'Fair Launch', text: 'Anti-bot and anti-whale mechanisms' },
      { icon: 'fa-link', title: 'Multi-Chain', text: 'Launch on Ethereum, BSC, Polygon simultaneously' },
      { icon: 'fa-lock', title: 'Vesting', text: 'Built-in token vesting for teams and investors' },
      { icon: 'fa-shield-alt', title: 'KYC/Audit', text: 'Verified teams and audited contracts' },
      { icon: 'fa-coins', title: 'Staking', text: 'Stake ALGO for allocation tiers' }
    ],
    stats: { raised: '$25M+', projects: '45+', roi: '12x Avg', chains: '5' },
    tech: ['Solidity', 'Python', 'TensorFlow', 'React', 'Node.js', 'TheGraph']
  },
  {
    id: 'dchain-bridge',
    slug: 'd-chain-bridge',
    htmlFile: '/dchain-bridge/index.html',
    title: 'D-Chain Bridge',
    tagline: 'Cross-Chain Asset Bridge',
    category: 'Infrastructure',
    color: 'gold',
    icon: 'fa-bridge',
    description: 'Secure cross-chain bridge supporting 15+ networks with fast finality and low fees.',
    heroDescription: 'D-Chain Bridge connects the fragmented blockchain ecosystem. Transfer assets between 15+ networks with institutional-grade security, fast finality, and the lowest fees in the market. One bridge to rule them all.',
    features: [
      { icon: 'fa-link', title: '15+ Networks', text: 'Ethereum, BSC, Polygon, Arbitrum, Solana, and more' },
      { icon: 'fa-bolt', title: 'Fast Finality', text: 'Most transfers complete in under 5 minutes' },
      { icon: 'fa-shield-alt', title: 'Secure', text: 'Multi-sig validators and insurance fund' },
      { icon: 'fa-percentage', title: 'Low Fees', text: '0.1% flat fee, no hidden costs' },
      { icon: 'fa-history', title: 'Track', text: 'Real-time status updates for all transfers' },
      { icon: 'fa-code', title: 'SDK', text: 'Integrate bridging into your dApp' }
    ],
    stats: { bridged: '$500M+', transfers: '1M+', chains: '15+', uptime: '99.9%' },
    tech: ['Solidity', 'Rust', 'Go', 'React', 'Node.js', 'LayerZero']
  },
  {
    id: 'alzee-protocol',
    slug: 'alzee-protocol',
    htmlFile: '/alzee-protocol/index.html',
    title: 'Alzee Protocol',
    tagline: 'NFT & Metaverse Platform',
    category: 'Metaverse',
    color: 'purple',
    icon: 'fa-vr-cardboard',
    description: 'Immersive metaverse with NFT land, virtual events, social spaces, and creator economy.',
    heroDescription: 'Alzee Protocol is your gateway to the metaverse. Own virtual land as NFTs, attend concerts and events, build and monetize experiences, and connect with a global community. The metaverse is here, and it\'s called Alzee.',
    features: [
      { icon: 'fa-map', title: 'NFT Land', text: '100,000 land parcels with location-based value' },
      { icon: 'fa-calendar-alt', title: 'Events', text: 'Concerts, conferences, and virtual meetups' },
      { icon: 'fa-paint-brush', title: 'Build', text: 'No-code tools to create experiences' },
      { icon: 'fa-store', title: 'Commerce', text: 'Sell virtual goods and services' },
      { icon: 'fa-user-friends', title: 'Social', text: 'Avatar customization and social features' },
      { icon: 'fa-coins', title: 'Earn', text: 'Monetize your creations and land' }
    ],
    stats: { land: '50K+ Sold', users: '200K+', events: '500+', creators: '5,000+' },
    tech: ['Unity', 'WebGL', 'Solidity', 'Node.js', 'IPFS', 'Three.js']
  }
];

export const getProjectById = (id) => projects.find(p => p.id === id);
export const getProjectBySlug = (slug) => projects.find(p => p.slug === slug);

export default projects;
